import { Box, Typography } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import { useFields } from "../../../../api/useFields";
import { formatDateCompact } from "../../../../utils/dateUtils";
import { findField } from "../../../../utils/findField";
import { getChipLabel } from "../../../../components/chips/CustomChip";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { BaseTimelineItem } from "./BaseTimelineItem";
import type { LogbookSessionItem as LogbookSessionItemType } from "../../types";

type LogbookSessionItemProps = {
	session: LogbookSessionItemType;
	isSelected: boolean;
	onSelect: () => void;
	linkUrl?: string;
};

export const LogbookSessionItem = ({ session, isSelected, onSelect, linkUrl }: LogbookSessionItemProps) => {
	const dateLabel = formatDateCompact(session.start_date);
	const serviceName = session.service?.name ?? "";
	const { formatedFields } = useFields("sessions");
	const statusField = findField(formatedFields, "status");
	const statusColor = statusField?.settings?.display_options?.choices?.find((choice: any) => choice.value === session.status);
	const accentColor = statusColor?.background ?? "#9e9e9e";

	return (
		<BaseTimelineItem config={{
			accentColor,
			icon: <CalendarMonth sx={{ fontSize: 14, color: accentColor }} />,
			isSelected,
			linkUrl,
		}}>
			<Box onClick={onSelect} sx={{ flex: 1, cursor: "pointer" }}>
				<Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
					<Typography variant="body2" fontWeight={600} color="primary.main">
						{serviceName}
					</Typography>
					{statusField && session.status && (
						<Box sx={{ transform: "scale(0.8)", transformOrigin: "left" }}>
							<ColoredLabelChip label={getChipLabel(statusField, session.status) ?? ""} color={accentColor} />
						</Box>
					)}
				</Box>
				<Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block", fontSize: "0.65rem" }}>
					{dateLabel}
				</Typography>
			</Box>
		</BaseTimelineItem>
	);
};
